import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzMenuModule } from 'ng-zorro-antd/menu';

import { UiIconsModule } from 'ui-icons';

import { VerticalMenuItem } from './vertical-navigation-menu.model';

@Component({
  selector: 'ui-platform-vertical-navigation-menu',
  templateUrl: './vertical-navigation-menu.component.html',
  styleUrl: './vertical-navigation-menu.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NzAnchorModule,
    UiIconsModule,
    TranslocoPipe,
    NzMenuModule,
    RouterModule
  ]
})
export class VerticalNavigationMenuComponent {
  @Input() navigationItems: VerticalMenuItem[] | null = null;
  @Input() currentPage: string | undefined;
  @Output() linkChange: EventEmitter<string> = new EventEmitter<string>();

  hasChildren(item: VerticalMenuItem): boolean {
    return !!item.children?.length;
  }

  onMenuItemClick(event: string): void {
    this.linkChange.emit(event);
  }
}
